module.exports = __webpack_public_path__ + "img/banner_image_ylms.357b0bd1.png";